import React from 'react';
import DesktopComments728x90Gak from './gak/DesktopComments728x90';
const DesktopComments728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Gak, {
        safety: safety
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
